import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "clsx";

import OddsForBet from "./OddsForBet";
import SetBetsFromBackend from "./SetBetsFromBackend";

import "./../../scss/Bets/index.scss";

import { useGlobalDataContext } from "../../../GlobalDataContext";

import ActionButton from "../../components/ActionButton";

const Bets = () => {
  const { dispatch } = useGlobalDataContext();
  const { t } = useTranslation();
  const [betsCount, setBetsCount] = useState(0);

  // show betslip on mobile devices
  const onShowBetslipEventListener = event => {
    dispatch({
      type: "SLIDE_ASIDE_BLOCK",
      payload: "betSlip"
    });
  };

  // show result history on mobile devices
  const onShowEventHistoryEventListener = event => {
    dispatch({
      type: "SLIDE_ASIDE_BLOCK",
      payload: "eventHistory"
    });
  };

  return (
    <section
      className={cn("event-odds")}
    >
      <div className="event-odds-block">
        <OddsForBet/>
      </div>

      <ActionButton
        onclick={onShowEventHistoryEventListener}
        classesName={cn("show-result-history-button hide-for-desktop", {
          inactive: false
        })}
        buttonBlinkDisable={true}
      >
        <span>{t("bets.resultHistory")}</span>
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 32 32"
          className="history-button-svg"
        >
          <path
            fill="currentColor"
            d="M29.602 8.002l-13.6 11.562-13.6-11.562-2.4 2.752 16 13.764 16-13.764z"
          />
        </svg>
        <div className="history-button-divider" />
      </ActionButton>
      <ActionButton
        onclick={onShowBetslipEventListener}
        classesName={cn("show-betslip-button hide-for-desktop", {
          inactive: false
        })}
      >
        {t("bets.coupons")}{" "}
        <span>{`${betsCount}`}</span>
      </ActionButton>
      <SetBetsFromBackend></SetBetsFromBackend>
    </section>
  );
};

export default Bets;
